export const WRITING_LABEL_GROUPS = [
  {
    name: "Engineering",
    labels: [
      "Mobile App Development",
      "Web App Development",
      "Backend Engineering",
      "Artificial Intelligence",
      "Blockchain",
    ],
  },
  {
    name: "How I Think",
    labels: ["How I solve problems", "Productivity", "Psychology", "Neuroscience", "Research"],
  },
  {
    name: "What I Build & Explore",
    labels: ["Projects", "Experiments", "Open Source", "Learning"],
  },
  {
    name: "Beyond Technology",
    labels: ["Volunteering", "Humanitarian Work", "Social Impact"],
  },
] as const;

export type WritingLabel = (typeof WRITING_LABEL_GROUPS)[number]["labels"][number];

export const toggleWritingLabel = (labels: string[], label: string): string[] =>
  labels.includes(label) ? labels.filter((item) => item !== label) : [...labels, label];
